import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import { moneyFormatter } from '../../helper';
import { useDispatch, useSelector } from 'react-redux';
import { API } from '../../api/api';
import { getTahun } from '../../utils/Filter';
import EmptyData from './EmptyData';

HighchartsMore(Highcharts);

const FindPriceUnitCondition = () => {
  const dispatch = useDispatch();
  const { chart, selected_cari_harga } = useSelector((state) => state.checkPriceReducer);

  const [yearList, setYearList] = useState([{ value: '2004', label: '2004' }]);

  // year options will be between selected start year to end year
  function filterByYear(value) {
    return value.value >= selected_cari_harga.startYear && value.value <= selected_cari_harga.endYear;
  }

  useEffect(() => {
    getTahun(
      selected_cari_harga.brand,
      selected_cari_harga.series,
      selected_cari_harga.tipe,
      selected_cari_harga.silinder
    ).then((res) => setYearList(res.filter(filterByYear)));
  }, []);

  const colors = ['#f0a18c', '#f05377', '#b85382', '#564887', '#074c89'];
  const grades = ['A', 'B', 'C', 'D', 'E'];

  function onChangeYear(event) {
    axios
      .get(API.service.unit_condition, {
        params: {
          ...selected_cari_harga,
          year: event.target.value,
        },
      })
      .then((res) => {
        const data = res.data.data;
        let series1 =
          data.item.length > 0
            ? [
                {
                  name: data.title,
                  data: grades.map((grade, i) => {
                    const { hargaTerendah, hargaTertinggi } = data.item.find((e) => e.grade === grade) || {
                      hargaTerendah: null,
                      hargaTertinggi: null,
                    };
                    return {
                      color: colors[i],
                      low: hargaTerendah != null ? parseInt(hargaTerendah) : null,
                      high: hargaTertinggi != null ? parseInt(hargaTertinggi) : null,
                    };
                  }),
                  minPointLength: 5,
                },
              ]
            : null;

        dispatch({
          type: 'SET_CHART',
          value: {
            ...chart,
            chart1: {
              series: series1,
              title: data.title,
            },
          },
        });
      });
  }

  const options = {
    chart: {
      type: 'columnrange',
      renderTo: 'chart1',
    },
    title: {
      text: chart.chart1 ? chart.chart1.title : '',
    },
    subtitle: {
      text: 'Harga terbentuk (Min Max) berdasarkan kondisi unit',
    },
    xAxis: {
      title: { text: '<span class="d-none d-sm-block">Grade Kendaraan</span>' },
      categories: ['A', 'B', 'C', 'D', 'E'],
    },
    yAxis: {
      min: 0,
      title: {
        text: '<span class="d-none d-sm-block">Harga Kendaraan</span>',
      },
      labels: {
        formatter: function () {
          return moneyFormatter(this.value);
        },
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size:12px; font-weight: bold">GRADE {point.key}</span><table>',
      pointFormat: `<tr style="font-size: 14px">
          <td style="padding:0">Harga Termurah</td>
          <td style="padding:0px 5px;">: {point.low} Juta</td>
      </tr>
      <tr style="font-size: 14px">
          <td style="padding:0">Harga Termahal</td>
          <td style="padding:0px 5px;">: {point.high} Juta</td>
      </tr>`,
      footerFormat: '</table>',
      shared: true,
      useHTML: true,
      formatter: function () {
        const { high, low } = this.points[0].point;
        return (
          `<span style="font-size:12px; font-weight: bold">GRADE ${this.x}</span><table>` +
          `<tr style="font-size: 14px">
                  <td style="padding:0">Harga Termahal</td>
                  <td style="padding:0px 5px;">:Rp. ${moneyFormatter(high)}</td>
              </tr>
              <tr style="font-size: 14px">
                  <td style="padding:0">Harga Termurah</td>
                  <td style="padding:0px 5px;">:Rp. ${moneyFormatter(low)}</td>
              </tr></table>`
        );
      },
    },
    responsive: [],
    credits: { enabled: false },
    legend: { enabled: false },
    series: chart.chart1 && chart.chart1.series ? [...chart.chart1.series] : [],
  };

  return (
    <div id="chart1" className="col-xl-12">
      {selected_cari_harga.startYear !== selected_cari_harga.endYear && (
        <div className="w-100 d-flex align-items-center justify-content-end py-2">
          <select className="filter-year" onChange={(e) => onChangeYear(e)}>
            {yearList.map((item, index) => {
              return (
                <option
                  value={item.value}
                  key={index}
                  selected={selected_cari_harga.year === item.value}
                  disabled={item.value === 'label'}
                >
                  {item.label}
                </option>
              );
            })}
          </select>
        </div>
      )}
      {chart.chart1.series ? (
        <HighchartsReact highcharts={Highcharts} options={options} />
      ) : (
        <EmptyData title={options.title.text} subTitle={options.subtitle.text} />
      )}
    </div>
  );
};

export default FindPriceUnitCondition;
